var popText = function() {

  var ease = Elastic.easeOut;

  var options = {
    repeat: -1,
    repeatDelay: 0.3,
    yoyo: true
  };

  CSSPlugin.useSVGTransformAttr = true;

  var tl = new TimelineMax(options),
    path = '.popText',
    stagger_val = 0.1,
    duration = 2;

  $.each($(path), function(i, el) {
    tl.set($(this), {
      scale: 0.6,
      opacity: 0
    });
  });

  var stagger_opts_to = {
    scale: 1,
    opacity: 1,
    ease: ease,
  };

  tl.staggerTo(path, duration, stagger_opts_to, stagger_val);

};

$(function(){
  $(window).on('beforeunload', function(){
    popText();
  });
});

// sticky haeder device setting
$(function(){
  var w = window.innerWidth ? window.innerWidth: $(window).width();
  var h = window.innerHeight ? window.innerHeight: $(window).height();
  var home = window.location.pathname;
  var host = window.location.protocol + '//' + window.location.hostname;

  if ( w > 768 ) {

    if ( home === '/' ) {
      $('.m-nav-item > a').removeClass('hvr-underline-from-center').addClass('hvr-underline-from-center-white');
    }

    $(window).scroll(function(){
      var ypx = $(window).scrollTop();
      if (ypx > 90) {
        $('header.m-header').removeClass('m-header-textBlack-after m-header-textBlack').addClass('m-header-textWhite');
        $('.m-nav-item > a').removeClass('hvr-underline-from-center').addClass('hvr-underline-from-center-white');
        if (host === 'https://vivivit.co.jp') {
          $('.header-viviho').css('background-image', 'url(' + host + '/wordpress/wp-content/themes/cvivivit/assets/images/symbols/logo_viviho_white@2x.png)').addClass('smallHeaderViviho');
        } else {
          $('.header-viviho').css('background-image', 'url(' + host + '/wp-content/themes/cvivivit/assets/images/symbols/logo_viviho_white@2x.png)').addClass('smallHeaderViviho');
        }
      } else if (ypx < 89) {
        if ( home === '/' ) {
          $('header.m-header').removeClass('m-header-textWhite').addClass('m-header-homeWhite');
        } else {
          $('header.m-header').addClass('m-header-textBlack-after m-header-textWhite').removeClass('m-header-textWhite').delay(500).queue(function(next){
            $(this).addClass('m-header-textBlack');
            next();
          });
          $('.m-nav-item > a').removeClass('hvr-underline-from-center-white').addClass('hvr-underline-from-center');
          if (host === 'https://vivivit.co.jp') {
            $('.header-viviho').css('background-image', 'url(' + host + '/wordpress/wp-content/themes/cvivivit/assets/images/symbols/logo_viviho@2x.png)').removeClass('smallHeaderViviho');
          } else {
            $('.header-viviho').css('background-image', 'url(' + host + '/wp-content/themes/cvivivit/assets/images/symbols/logo_viviho@2x.png)').removeClass('smallHeaderViviho');

          }
        }
      }

    });

  }

});


$(function(){

  var _touch = ('ontouchstart' in document) ? 'touchstart' : 'click';

  $('.menu-trigger').on(_touch, function(){
    $(this).toggleClass('active');
    return false;
  });

  $('#sb-site').on(_touch, function(){
    $('.menu-trigger').removeClass('active');
  });


});
